import { render, staticRenderFns } from "./input-perusahaan.vue?vue&type=template&id=53de1300&"
import script from "./input-perusahaan.vue?vue&type=script&lang=js&"
export * from "./input-perusahaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports